export const SERVICE_LEVEL = {
  NORMAL: 'Normal',
  RUSH: 'Rush',
} as const;

export const API_CONTEXT = {
  STANDARD: 'standard',
} as const;

export const ORDER_CATEGORY = {
    SUBPOENA_TO_BE_PREPARED: 'subpoena-to-be-prepared',
    AUTHORIZATION_NOT_PROVIDED: 'authorization-not-provided',
    RECORD_RETRIEVAL:'record-retrieval',
    TOAST_SUMMARY_ERROR: 'ERROR'
} as const;